import { openTelegramLink } from '@tma.js/sdk-react'

/** Открыть t.me-ссылку внутри Telegram; вне Telegram — в новой вкладке. */
export function openTgLink(url: string): void {
  try {
    if (openTelegramLink.isAvailable()) {
      openTelegramLink(url)
      return
    }
  } catch {
    // запасной путь ниже
  }
  window.open(url, '_blank', 'noopener,noreferrer')
}

/** «Поделиться в Telegram»: выбор чата и готовый текст со ссылкой. */
export function shareToTelegram(url: string, text?: string): void {
  const params = new URLSearchParams({ url })
  if (text) params.set('text', text)
  openTgLink(`https://t.me/share/url?${params.toString()}`)
}

export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    // WebView без Clipboard API — старый способ
    try {
      const ta = document.createElement('textarea')
      ta.value = text
      ta.setAttribute('readonly', '')
      ta.style.position = 'fixed'
      ta.style.opacity = '0'
      document.body.appendChild(ta)
      ta.select()
      const ok = document.execCommand('copy')
      ta.remove()
      return ok
    } catch {
      return false
    }
  }
}
